import { Footer } from "../components/Footer";
import { Nav } from "../components/Nav";
import ServiceDetails from "../components/ServiceDetails";
import { Seo } from "../components/Seo";

export default function CivilEngineering() {
	return (
		<>
			<Seo title="Austin Civil Engineering & Site Development | Gova" description="Civil site design, grading, drainage, detention, water quality, and subdivision engineering for Central Texas development projects." path="/civil-engineering" serviceName="Civil Engineering and Site Development" />
			<Nav />
			<ServiceDetails
				service="civil-engineering"
				onBack={() => window.history.back()}
			/>
			<Footer />
		</>
	);
}
